import React, { useCallback } from "react";
import { makeStyles } from "@material-ui/core/styles";
import LanguageHelper from "../../../helpers/LanguageHelper";
import FetchData from "./FetchData";
import GetOptions from "./GetOptions";
import { List, ListItem, ListItemText } from "@material-ui/core";
import CustomSnackbar from "../../../components/Snackbar/Snackbar";
import TableBackdrop from "../../../components/Table/TableBackdrop";
import Table from "../../../components/Table/Table";

const useStyles = makeStyles(() => ({
  details: {
    padding: 10,
    fontSize: 30,
    textAlign: "center",
    color: "white",
    backgroundColor: "#2D3446",
  },
  root: {
    maxHeight: 300,
    overflow: "auto",
  },
  addButton: {
    marginLeft: "12px",
  },
  editButton: {
    marginLeft: "12px",
  },
  list: {
    height: 100,
    overflow: "auto",
  },
}));

export default function TicketTable() {
  const language = LanguageHelper.getLanguage();
  const tableRef = React.useRef();
  const classes = useStyles();

  const [numOfEntries, setNumOfEntries] = React.useState(0);
  const [columns, setColumns] = React.useState([]);
  const [snackbar, setSnackbar] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [severity, setSeverity] = React.useState("info");
  const [backdropLoading, setBackdropLoading] = React.useState(true);

  const init = useCallback(async () => {
    setColumns([
      { title: "Proje Adı", field: "title"},
      { title: "Güncellenme Tarihi", field: "lastUpdated"},
      { title: "Toplam Açık Destek Talebi", field: "total" },
      { title: "Waiting For Support", field: "waitingForSupportCount" },
      { title: "In Progress", field: "inProgressCount" },
      { title: "Waiting For Customer", field: "waitingForCustomerCount" },
    ]);
    setBackdropLoading(false);
  }, [classes]);
  React.useEffect(() => {
    init();
  }, [init]);

  return (
    <>
      <TableBackdrop backdropLoading={backdropLoading} />
      <CustomSnackbar
        snackbar={snackbar}
        setSnackbar={setSnackbar}
        snackbarMessage={snackbarMessage}
        severity={severity}
      />
      <Table
        noRowActions
        tableName="Destek Talepleri"
        authName="tickets"
        columns={columns}
        tableRef={tableRef}
        setSnackbar={setSnackbar}
        setSnackbarMessage={setSnackbarMessage}
        setSeverity={setSeverity}
        fetchData={FetchData}
        numOfEntries={numOfEntries}
        setNumOfEntries={setNumOfEntries}
        isDeletable={false}
        isEditHidden={true}
        isTransferable={false}
        // rowStyle={(rowData) => ({
        //   backgroundColor: !rowData.isActive && "#804f4f",
        // })}
        detailsWindow={(rowData) => window.open("/user/" + rowData.id)}
        disabled={(rowData) => !rowData.isActive}
      />
    </>
  );
}
